import React, { useEffect, useState } from "react";
import SelectCompanyLogo from "../admin/Presentation/Components/SelectCompanyLogo";
import MyInput from "../../../components/formComponents/MyInput";
import UploadFileStyleTwo from "../admin/Presentation/Components/UploadFileStyleTwo";
import { Button } from "@chakra-ui/react";
import axios from "axios";
import { getAxiosConfig } from "../../../utils/helpers";
import { toast } from "react-toastify";
import { Outlet, useOutletContext } from "react-router-dom";
import { designStyle } from "../../../utils/options";
import MySelect from "../../../components/formComponents/MySelect";
import { MAX_COMPANY_NAME_LENGTH } from "../../../utils/constant";

const initialData = {
  companyName: "",
  companyLogo: [],
  floorMap: [],
  address: "",
  // designStyle: "",
};
const BasicInfo = () => {
  const [formdata, setFormdata] = useState(initialData);
  const [isLoading, setIsLoading] = useState(false);
  const { projectData, basicInfo, setBasicInfo } = useOutletContext();
  console.log("BASIC INFO", basicInfo, formdata);

  const postData = async () => {
    console.log("JSON DATA", formdata);
    const { companyLogo, companyName, address, floorMap } = formdata;
    if (companyName && companyName.trim() === "") {
      toast.error("Company Name is required");
      return;
    }
    if (companyName && companyName.length > MAX_COMPANY_NAME_LENGTH) {
      toast.error(
        `Company Name should be less than ${MAX_COMPANY_NAME_LENGTH} characters`,
      );
      return;
    }
    if (address && address.trim() === "") {
      toast.error("Address is required");
      return;
    }
    if (companyLogo.length === 0) {
      toast.error("Company Logo is required");
      return;
    }
    // if (floorMap.length === 0) {
    //   toast.error("Floor Plan is required");
    //   return;
    // // }
    // if (formdata.designStyle && formdata.designStyle.trim() === "") {
    //   toast.error("Design Style is required");
    //   return;
    // }
    const FORMDATA = new FormData();
    FORMDATA.append("companyName", formdata.companyName);
    FORMDATA.append("address", formdata.address);
    FORMDATA.append("companyLogo", formdata.companyLogo[0]);
    formdata.floorMap[0] && FORMDATA.append("floorMap", formdata.floorMap[0]);
    FORMDATA.append("projectId", projectData?._id);
    // FORMDATA.append("designStyle", formdata?.designStyle);
    console.log("FORMDATA", FORMDATA);
    setIsLoading(true);

    try {
      if (formdata?._id) {
        const { data } = await axios.put(
          `${process.env.REACT_APP_BACK_URL}/api/presentation/update-base`,
          FORMDATA,
          getAxiosConfig({}, true),
        );
        setFormdata(data.data);
        setBasicInfo(data.data);
        toast.success("Basic Info Updated Successfully");
      } else {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BACK_URL}/api/presentation/add-base`,
          FORMDATA,
          getAxiosConfig({}, true),
        );
        setFormdata(data.data);
        setBasicInfo(data.data);
        toast.success("Basic Info Added Successfully");
      }
    } catch (error) {
      console.error("Error posting basic info:", error);
      toast.error(
        error?.response?.data?.message ||
          error?.message ||
          "Error Submitting Basic Info",
      );
      // Handle error appropriately, e.g., show a notification or alert
    } finally {
      setIsLoading(false);
    }
  };

  const getData = async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_BACK_URL}/api/presentation/get-base/${projectData?._id}`,
        getAxiosConfig(),
      );
      console.log(data);
      setFormdata(data.data);
    } catch (error) {}
  };

  useEffect(() => {
    projectData?._id && basicInfo && setFormdata(basicInfo);
  }, [projectData?._id, basicInfo]);

  return (
    <div className="container mx-auto p-4 ">
      <h2 className="text-xl">Fill The Basic Information</h2>
      <div className="grid grid-cols-2 gap-4 mt-8 ">
        <div>
          <SelectCompanyLogo
            setImage={(image) => {
              setFormdata((prev) => ({ ...prev, companyLogo: [image] }));
            }}
            image={formdata.companyLogo?.[0]}
          />
        </div>

        {/* <div>
          <UploadFileStyleTwo
            label={"Floor Map"}
            file={formdata.floorMap}
            // required={true}
            setFile={(file) => {
              // console.log(file, "file in floor map");
              setFormdata((prev) => ({
                ...prev,
                floorMap: [...file],
              }));
            }}
          />
        </div> */}
        <div>
          <MyInput
            required={true}
            placeholder={"Type here Company Name"}
            label={"Company Name"}
            value={formdata.companyName}
            onChange={(e) =>
              setFormdata((prev) => ({ ...prev, companyName: e.target.value }))
            }
            error={
              formdata?.companyName?.length > MAX_COMPANY_NAME_LENGTH
                ? `Company name should be less than ${MAX_COMPANY_NAME_LENGTH} characters`
                : false
            }
          />
        </div>
        <div>
          <MyInput
            required={true}
            placeholder={"Type here Company Address"}
            label={"Address"}
            value={formdata.address}
            onChange={(e) =>
              setFormdata((prev) => ({ ...prev, address: e.target.value }))
            }
          />
        </div>
        {/* <div>
          <MySelect
            required={true}
            placeholder={"Select Design Style"}
            label={"Design Style"}
            value={formdata.designStyle}
            options={designStyle.map((v) => v.name)}
            onChange={(val) =>
              setFormdata((prev) => ({ ...prev, designStyle: val }))
            }
          />
        </div> */}
      </div>
      <div className="mt-4 flex justify-end ">
        <Button
          isLoading={isLoading}
          loadingText="Submitting..."
          colorScheme="teal"
          onClick={postData}
          disabled={!projectData?._id}
        >
          Submit
        </Button>
      </div>
    </div>
  );
};

export default BasicInfo;
